import { render, staticRenderFns } from "./exposure.vue?vue&type=template&id=5536df25&"
import script from "./exposure.vue?vue&type=script&lang=js&"
export * from "./exposure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports